import { Component } from 'react';
import ReactDOM from 'react-dom/client';
import { useSelector } from 'react-redux';
import fetch from 'unfetch';
import NotificationComponent from '../../components/sgvmap/NotificationComponent';
import { user_state } from '../../features/user/userSlice';
import { store } from '../../app/store'

const API_URL = "/"

async function checkStatus(response) {

    //console.log('respues', response.json())

    if (response.ok) {
        return response;

    }
    //console.log('respues', response)

    var text = JSON.parse(await response.text());


    const messages = ReactDOM.createRoot(document.getElementById('messages'));
    messages.render(
        <NotificationComponent type="error" text={text.message}></NotificationComponent>
    );


    // convert non-2xx HTTP responses into errors:   
    const error = new Error(response.statusText);
    console.log('errossss', error)
    error.response = response;
    return Promise.reject(error);

}

function getQueryString(params) {
    let strings = []
    for (let key in params) {
        strings.push(key + "=" + encodeURIComponent(params[key]))
    }
    return strings.join("&")
}

export class CommonService {


    //static dispatch = store.useDispatch();
    //static userstate = store.useSelector(user_state);

    static list(url) {
        const state = store.getState();
        return (
            fetch(API_URL + url, {
                headers: {
                    'Authorization': state.user.logged ? "Bearer " + state.user.token : ""
                }
            })
                .then(checkStatus)
                .then((resJson) => {
                    const data = resJson.json()
                    return data;
                })
        );
    }

    static get = (url) => {
        const state = store.getState();
        //console.log('url ', url)
        return (
            fetch(API_URL + url, {
                headers: {
                    'Authorization': state.user.logged ? "Bearer " + state.user.token : ""
                }
            }).then(checkStatus)
                .then((resJson) => {
                    const data = resJson.json()
                    return data;
                })
        )
    }

    static getWithToken = (url, token) => {

        return (
            fetch(API_URL + url, {
                headers: {
                    'Authorization': "Bearer " + token
                }
            }).then(checkStatus)
                .then((resJson) => {
                    const data = resJson.json()
                    return data;
                })
        )
    }

    static post = (url, bean) => {
        const state = store.getState();
        return (
            fetch(API_URL + url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': state.user.logged ? "Bearer " + state.user.token : ""
                },
                method: 'POST',
                body: JSON.stringify(bean)
            }).then(checkStatus)
                .then((resJson) => {
                    const data = resJson.json()
                    return data;
                })
        )
    }

    static postPhoto = (url, bean) => {
        //console.log('url postPhoto', url)
        //console.log('bean postPhoto', bean)

        const state = store.getState();
        return (
            fetch(url, {
                headers: {
                    //'Content-Type': 'multipart/form-data',
                    'Authorization': state.user.logged ? "Bearer " + state.user.token : "",
                },
                method: 'POST',
                body: bean
            }).then(checkStatus)
                .then((resJson) => {
                    //console.log('respuesta', resJson)
                    const data = resJson.json()
                    //console.log('datos', data)
                    return data;
                })
        )
    }

    static update = (url, bean) => {
        const state = store.getState();
        return (fetch(API_URL + url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': state.user.logged ? "Bearer " + state.user.token : ""
            },
            method: 'PUT',
            body: JSON.stringify(bean)
        }
        ).then(checkStatus))
            .then((resJson) => {
                const data = resJson.json()
                return data;
            })
    }

    static delete = (url) => {
        const state = store.getState();
        return (
            fetch(API_URL + url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': state.user.logged ? "Bearer " + state.user.token : ""
                },
                method: 'DELETE'
            }).then(checkStatus))
    }
}
